import {ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OrderRes, PosItemVarianceModel, PosItemVarianceOptionModel} from "../../../@services/gen";
import {OrderItem} from "../../../@services/gen/model/orderItem";
import {FeatureService} from "../../../@services/feature.service";
import OrderTypeEnum = OrderRes.OrderTypeEnum;

@Component({
  selector: 'app-pos-item-dialog',
  templateUrl: './pos-item-dialog.component.html',
  styleUrls: ['./pos-item-dialog.component.scss'],
})
export class PosItemDialogComponent implements OnInit {
  @ViewChild('priceInput') priceInput: ElementRef;
  orderItem: OrderItem = {
    quantity: 0,
    instructions: '',
  };
  quantityInput: string = '1';

  varianceModel: PosItemVarianceModel[] = [];
  selectedVariants: PosItemVarianceModel[] = [];
  allowEditPrice: boolean = false;
  prepareType: OrderTypeEnum;

  constructor(private dialogRef: MatDialogRef<PosItemDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: any,
              private cdr: ChangeDetectorRef, private fs:FeatureService) {}

  ngOnInit(): void {
    if(this.fs.isFeatureEnabled('allowEditPrice')){
      this.allowEditPrice = true;
    } else {
      this.allowEditPrice = false;
    }

    this.orderItem = this.data.orderItem;
    this.normalizeQuantity(this.orderItem.quantity);

    this.prepareType = this.data.activeTab;

    this.varianceModel = [];
    if (!this.orderItem.varianceModel) {
      this.varianceModel = this.orderItem.posItemVsMerchant.posItem.varianceModel;

      this.setDefaultSelected(this.varianceModel);
    } else {
      this.varianceModel = this.orderItem.posItemVsMerchant.posItem.varianceModel;

      this.setSelectedItem();
    }

  }

  onQuantityInput(value: string) {
    const digitsOnly = String(value ?? '').replace(/\D/g, '');
    this.quantityInput = digitsOnly;

    if (!digitsOnly) {
      return;
    }

    const parsedQuantity = Number.parseInt(digitsOnly, 10);
    this.orderItem.quantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
  }

  normalizeQuantity(value?: unknown) {
    const parsedQuantity = this.parseQuantity(value ?? this.quantityInput ?? this.orderItem.quantity);
    const normalizedQuantity = Number.isFinite(parsedQuantity) && parsedQuantity >= 1 ? parsedQuantity : 1;
    this.orderItem.quantity = normalizedQuantity;
    this.quantityInput = normalizedQuantity.toString();
  }

  private parseQuantity(value: unknown): number {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? Math.floor(value) : Number.NaN;
    }

    const digitsOnly = String(value ?? '').replace(/\D/g, '');
    if (!digitsOnly) {
      return Number.NaN;
    }

    return Number.parseInt(digitsOnly, 10);
  }

  setDefaultSelected(varianceModel) {
    this.varianceModel = varianceModel.map((x) => ({
      ...x,
      options: x.options.map((option) => ({
        ...option,
        selected: option.defaultSelection,
      })),
    }));

    this.varianceModel.forEach((variant) => {
      variant.options.forEach((option) => {
        if (option.selected) {
          this.selectAddon(variant, option);
        }
      });
    });

  }

  setSelectedItem() {
    this.selectedVariants = this.orderItem.varianceModel;
    this.cdr.detectChanges();
  }

  submit() {
    this.normalizeQuantity();
    this.orderItem.averageCost = this.orderItem.quantity * (this.orderItem.averageCost ?? 0);
    this.dialogRef.close(this.orderItem);
  }

  addQty() {
    this.normalizeQuantity();
    this.orderItem.quantity += 1;
    this.quantityInput = this.orderItem.quantity.toString();
  }

  minusQty() {
    this.normalizeQuantity();
    if (this.orderItem.quantity > 1) {
      this.orderItem.quantity -= 1;
    }
    this.quantityInput = this.orderItem.quantity.toString();
  }

  selectAddon(variant: PosItemVarianceModel, varianceOption: PosItemVarianceOptionModel) {
    const index = this.selectedVariants.findIndex((v) => v.title === variant.title);
    if (index > -1) {
      const optionIndex = this.selectedVariants[index].options.findIndex((o) => o.name === varianceOption.name);
      if (this.selectedVariants[index].type === 'option') {
        this.selectedVariants[index].options = [];
      }
      if (optionIndex === -1) {
        this.selectedVariants[index].options.push(varianceOption);
      } else {
        this.selectedVariants[index].options.splice(optionIndex, 1);
      }
    } else {
      this.selectedVariants.push({...variant, options: [varianceOption]});
    }

    this.orderItem.varianceModel = this.selectedVariants;
    this.orderItem.variance = JSON.stringify(this.selectedVariants);
  }

  hasVarianceOption(variant: PosItemVarianceModel, variantOption: PosItemVarianceOptionModel) {
    for (let v of this.selectedVariants) {
      if (v.title === variant.title) {
        return v.options.findIndex((x) => x.name === variantOption.name) > -1;
      }
    }
    return false;
  }

  protected readonly OrderTypeEnum = OrderTypeEnum;
}
